import axios from "axios";
import { fetch as fetchPolyfill } from "whatwg-fetch"; // added for IE , dont remove
import { isIOS, isAndroid } from "react-device-detect";
import { getCookie } from "../components/Helpers";
import { logApiInfo, logNewrelicNoticeError, getPageName } from "../utilities/logger";
import util from "../utilities/util";
import newrelic from "../utilities/newrelic";
import {getHttpClientRequest as getHttpCall,postHttpClientRequest as postHttpCall} from "@vz/react-util";
import Cookies from 'js-cookie';

const ostype = isIOS ? "mios" : isAndroid ? "mandroid" : "web";
const unAuthSessionId = Cookies.get('unAuthSessionId');
const  headers= {
  "intlHostName": window.location.origin,
  "unAuth": isUnAuth(),
  clientId: util.getClientId(),
  flowName: isUnAuth() ? "UnAuth-INTL" : "Auth-INTL",
  flowFromUnAuth : unAuthSessionId ? true : false,
  unAuthSessionId : unAuthSessionId ? unAuthSessionId : ""
};
const httpClient = axios.create({
  headers: {
    "Content-Type": "application/json",
    "intlHostName": window.location.origin,
    "unAuth": isUnAuth(),
    OsType: ostype,
    channelId: util.getChannelId(), //, e2erequestid: _dg_eReqId,
    clientId: util.getClientId(),
    flowName: isUnAuth() ? "UnAuth-INTL" : "Auth-INTL",
    session_id: typeof (_dg_sessid) != "undefined" ? _dg_sessid : ""
  },
  withCredentials: true
});

let started;
let apiRequest;
const apiTransitionReqNames = ['landing_page','destination_list','get_travel_dates','get_devices',
'get_plans','review_plan','select_effective_date','submit_offers','country_list_byplan','feature_comparison',
'review_plan','removeplan','removeplaneffectivedate','removeplanreview','removeplanconfirmation','cancelorder','pendingorder',
'device_compatibility_check', 'get_effective_dates', 'remarksSelection', 'generateOrSkipRemarks', 'reptool', 'app_landingPage', 'statementDetails', 'usage_Details'];

httpClient.interceptors.request.use(config => {
  let reqName = config?.url?.substring?.(config?.url?.lastIndexOf?.('/') + 1);
  reqName = reqName && reqName.split("?") && reqName.split("?")[0];
  if (!window?.performancemeasured) {
    newrelic.ajaxRequestStart(config)
  }
  if (apiTransitionReqNames?.includes(reqName)) {
    window?.performance?.mark('api-transition:start');
  }
  started = Date.now();
  apiRequest = config && config.data ? JSON.stringify(config.data) : "";
  return config;
});

const stringifyJSON = obj => {
  if (obj !== null && obj !== "") {
    if (typeof obj === "string") {
      return JSON.stringify(JSON.parse(obj));
    } else {
      return JSON.stringify(obj);
    }
  }
  return obj;
};

const logNewrelic = () => {
  try {
    let sessionId = getCookie("digital_ig_session");
    sessionId = sessionId ? sessionId : "";
    let newRelicTransName =
      util.getChannelId() +
      "/" +
      window.location.href +
      "/" +
      sessionId +
      "/" +
      _dg_eReqId;
    var newRelicObj = newrelic.interaction();
    newRelicObj.setName(newRelicTransName);
    newRelicObj.save();
  } catch (e) {}
};

var myData = {
  pauseandResume: reactGlobals.pastDue,
  pendingOrder: reactGlobals.pendingOrder
};
var data = JSON.stringify(myData);

httpClient.interceptors.response.use(
  response => {
    const apiResponseTime = Date.now() - started;
    const methodName = util.getApiMethodName(response.config.url);
    let pageName = reactGlobals.currentPage;
    let flowName = methodName;
    const headers = new Headers(response.config.headers);
    if (headers.has("PageName")) pageName = headers.get("PageName");
    if (headers.has("FlowName")) flowName = headers.get("FlowName");
    const headerData = util.getHeaders(headers);
    //console.log('## API RESPONSE LOGS ##', pageName, response.config.url, JSON.stringify(response.data), apiResponseTime, flowName, methodName, response.config.url, headerData, response.status);
    
    const requestUrl = (response && response.config && response.config.url) || '';
    let reqName = requestUrl?.substring?.(requestUrl?.lastIndexOf?.('/') + 1);
    reqName = reqName && reqName.split("?") && reqName.split("?")[0];
    let newrelicPageName = getPageName();
    if (!window?.performancemeasured) {
      newrelic.ajaxRequestEnd(reqName, newrelicPageName);
    }
    if (apiTransitionReqNames?.includes(reqName)) {
      window?.performance?.mark('api-transition:end');
      const measure = window?.performance?.measure('api-transition', 'api-transition:start', 'api-transition:end');
      newrelic.logApiTransitionMeasure(measure?.duration, reqName, newrelicPageName);
    }

    newrelic.performanceMeasure(100, newrelicPageName);
    let pageAttributes = response &&
          response.data && response.data && response.data.body && 
          response.data.body.pageAttributes;
    const accountRole =  pageAttributes && pageAttributes.find(i => i.itemKey == "accountrole") &&
              pageAttributes.find(i => i.itemKey == "accountrole").itemValue;

    const responsecode =
      response &&
      response.data &&
      response.data.responseInfo &&
      response.data.responseInfo.responseCode;
    /**let responseMessage = response && response.responseInfo && response.responseInfo.responseMessage;
    let body = response && response.body;
    let errorMessage = common.isError(responseCode, responseMessage, body);*/
    let errorMessage = '';
    
  
    _dg_eReqId = response && response.headers && response.headers.e2erequestid;
    let apiResponse = {
      responseInfo:
        response && response.data && response.data.responseInfo
          ? stringifyJSON(response.data.responseInfo)
          : "",
      eReqId: _dg_eReqId,
      amID: getCookie("amID")
    };

    const sResponseURL =
      response && response.request && response.request.responseURL;

    /* let confirmData=util.confirmData;  
  if(confirmData && sResponseURL && (sResponseURL.indexOf('submit_order') > -1 || sResponseURL.indexOf('confirmationPage.json') > -1)){
    myData = confirmData;
  } */
  let errorMsg = '';
  if(responsecode && responsecode != "000" && responsecode != "00" && responsecode != "0"){
  let sections = response &&
    response.data && response.data && response.data.body && 
    response.data.body.sections;

    let content = sections !== undefined && sections.find(s => s.sectionType == "errorSection");
    let errorHeader = content && content.contents[0].items.find(c => c.itemKey === "headerText") ? content.contents[0].items.find(c => c.itemKey === "headerText").itemValue : "";
    let errorSubHeader = content && content.contents[0].items.find(c => c.itemKey === "subHeaderText") ? content.contents[0].items.find(c => c.itemKey === "subHeaderText").itemValue : "";
    errorMsg = errorHeader+' ' +errorSubHeader;
  }

  let apiNameUrl = response.config.url;
  apiNameUrl = apiNameUrl.split("?")[0];
  apiNameUrl = apiNameUrl.split("/");
  apiNameUrl = apiNameUrl[apiNameUrl.length-1];
  console.log(apiNameUrl);
    
    console.log("logApiInfo SUCCESS----");
    // logApiInfo(
    //   pageName,
    //   apiRequest ? stringifyJSON(apiRequest) : stringifyJSON(headerData),
    //   stringifyJSON(apiResponse),
    //   apiResponseTime,
    //   reactGlobals.planType ? reactGlobals.planType : flowName,
    //   methodName,
    //   apiNameUrl,
    //   stringifyJSON(headerData),
    //   responsecode,
    //   responsecode === "000" || responsecode == "00" ? "success" : "failure",
    //   stringifyJSON(data),
    //   errorMessage,
    //   response.status
    // );

    if (
      responsecode === "408" ||
      (sResponseURL && (sResponseURL.indexOf("login.verizonwireless.com") || sResponseURL.indexOf("login.verizon.com")) > -1)
    ) {
      console.log("TIME OUT: CLEAR SESSION---");
      sessionStorage.clear();
      window.location.reload(true); // need to redirect to login page
    } else if (responsecode == "308") {
       if (window.location.hash != "#/") {
        //Setting this varaible to clear cache and make fresh VED API call
        reactGlobals.routeLog.reloadPage = true;
        // user directly lands on other pages
        window.location.hash = "/"; // redirect to landing page
      }      
    }
    else if (responsecode == "401" && util.showLinksForRole(accountRole) 
       && (window.location.hash != "#/" || window.location.hash != "#/manageplan")) {
      // user directly lands on other pages
      util.redirect("/", "forWard"); // redirect to landing page
    }
    //logNewrelic();
    return response;
  },
  error => {
    _dg_eReqId = error && error.response && error.response.headers && error.response.headers.e2erequestid ? error.response.headers.e2erequestid : _dg_eReqId;

    logNewrelicNoticeError(error,"DAPIError");
    const apiResponseTime = Date.now() - started;
    const methodName = util.getApiMethodName(error.config.url);
    let pageName = reactGlobals.currentPage;
    let flowName = methodName;
    const headers = new Headers(error.config.headers);
    if (headers.has("PageName")) pageName = headers.get("PageName");
    if (headers.has("FlowName")) flowName = headers.get("FlowName");
    const headerData = util.getHeaders(headers);
    // console.log('## API ERROR LOGS ##', pageName, response.config.url, stringifyJSON(response.data), apiResponseTime, flowName, methodName, response.config.url, headerData, response.status);
    let statuscode = "";
    let sResponseURL = "";
    let responsecode = "";
    let response = "";
    let errorMsg = '';
    let responseMessage = '';
    let body = '';
    let errorDesc = '';
    let responseBody = '';
    let sections = '';
    let content = '';
    let errorMessage = '';
    let apiError = '';
    console.log(response);
    try {
      
      if (error && (error.request || error.response)) {
        statuscode =
          error.request &&
          error.request.status != undefined &&
          error.request.status != null
            ? error.request.status
            : error.response && error.response.status
            ? error.response.status
            : "";
        sResponseURL =
          error.response &&
          error.response.request &&
          error.response.request.responseURL
            ? error.response.request.responseURL
            : "";
        responsecode =
          error.response &&
          error.response.data &&
          error.response.data.responseInfo &&
          error.response.data.responseInfo.responseCode
            ? error.response.data.responseInfo.responseCode
            : "";
        
        response =
          error.request && error.request.response
            ? error.request.response
            : error.response &&
              error.response.request &&
              error.response.request.response
            ? error.response.request.response
            : "";
            

            response = JSON.parse(response);
            //responseMessage = response && response.responseInfo && response.responseInfo.responseMessage;
            responseBody = response && response.body;
            sections = responseBody && responseBody.sections;

            content = sections && sections.find(s => s.sectionType == "errorSection");
            errorMessage = content && content.contents[0].items.find(c => c.itemKey === "headerText") ? content.contents[0].items.find(c => c.itemKey === "headerText").itemValue : "";
            console.log(sections);
            console.log(content);
    

            console.log(errorMessage);


            console.log(response);
          
                        
      }
    } catch (e) {}

    /* let confirmData=util.confirmData;  
  if(confirmData && error.config.url && (error.config.url.indexOf('submit_order') > -1 || error.config.url.indexOf('confirmationPage') > -1)){
    data = confirmData;
  } */
  console.log(errorMessage);
    console.log("logApiInfo ERROR----");
    //response = JSON.parse(response);
    //console.log(response);
    

    /*let responseBody1 = response && response.body;
    let sections1 = responseBody1 && responseBody1.sections;

    let content1 = sections1 && sections1.find(s => s.sectionType == "errorSection");
    let errorMessage1 = content1 && content1.contents[0].items.find(c => c.itemKey === "headerText") ? content1.contents[0].items.find(c => c.itemKey === "headerText").itemValue : "";
    
    console.log("responseBody" +responseBody1);
    console.log("sections1" +sections1);
    console.log("content1" +content1);
    console.log("errorMessage1" +errorMessage1);*/

   /* let apiNameUrl = response.config.url;
    apiNameUrl = apiNameUrl.split("?")[0];
    apiNameUrl = apiNameUrl.split("/");
    apiNameUrl = apiNameUrl[apiNameUrl.length-1];*/
  

    // logApiInfo(
    //   pageName,
    //   apiRequest ? stringifyJSON(apiRequest) : stringifyJSON(headerData),
    //   util.getErrorMessage(error),
    //   apiResponseTime,
    //   reactGlobals.planType ? reactGlobals.planType : flowName,
    //   methodName,
    //   error.config.url,
    //   stringifyJSON(headerData),
    //   (error && error.status) || statuscode,
    //   "failure", //status
    //   stringifyJSON(response),
    //   errorMessage,
    //   (error && error.status) || statuscode,
    // );
    return Promise.reject(error);

    /* 
// Dont Delete this code untill implementing code to handel 500 status code error
if(statuscode == "500" && error && error.response){
 return Promise.resolve(error.response);  
}else{
 return Promise.reject(error);
} */
  }
);

export function isUnAuth(url) {
  return window.location.pathname.indexOf("/nos/") > -1 ; 
}

export function shouldRedirectToNsaTrip(landingPage) {
  const throttling = landingPage?.nsaThrottlingAvailable;
  return throttling === true || throttling === 'true';
}

export function getHttpClientRequest(url, axConfig){
  axConfig.headers = {...axConfig.headers, ...headers}
  return getHttpCall(url, axConfig);
};

export function postHttpClientRequest(apiUrl, data, axConfig){
  axConfig.headers = {...axConfig.headers, ...headers}
  return postHttpCall(apiUrl, data, axConfig);
};
// export function getHttpClientRequest(apiUrl, axConfig) {
//   return httpClient.get(util.avoidCache(apiUrl), axConfig);
// }
// export function postHttpClientRequest(apiUrl, data, axConfig) {
//   return httpClient.post(util.avoidCache(apiUrl), data, axConfig);
// }
export default httpClient;
